module.exports = __webpack_public_path__ + "img/privilege10.5acebce2.png";